import React, { useContext, useState } from 'react'
import { SessionContext } from '../session-context'
import { parseISO } from 'date-fns'
import dateFormat from 'dateformat'
import AgentAvatar from '../AgentAvatar'
import { calendarStyles } from './calendarHelpers'
import DateRangeIcon from '@material-ui/icons/DateRange'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button'
import Check from '@material-ui/icons/Check'
import TextField from '@material-ui/core/TextField'
import { Typography } from '@material-ui/core'
import { Warning } from '@material-ui/icons'
import { createCalendarEvent, postMessage, registerEmailReminder } from '../js/data-providers'

function createCalendarEventWrap ({
  event_id,
  start,
  end,
  startTimestamp,
  endTimestamp,
  token,
  chatServiceUrl
}) {
  return createCalendarEvent({
    event_id,
    start,
    end,
    startTimestamp,
    endTimestamp,
    token,
    chatServiceUrl
  }).then(response => {
    if (response === false) {
      return false
    }
    postMessage('ga', { action: 'Meeting Booked', label: 'meeting' })
    return true
  })
}

function EmailReminderSection ({ firstName, completeDate, startTime, endTime, avatarUrl }) {
  const classes = calendarStyles()
  return (
    <>
      <div className={classes.calendarDropCompleteCard} style={{ display: 'flex', padding: 10, marginBottom: 15 }}>
        <div style={{ marginRight: 10 }}>
          <AgentAvatar avatarUrl={avatarUrl} size={65} />
        </div>
        <div style={{ margin: 'auto' }}>
          <div style={{ fontSize: '1.1em' }}>{firstName}</div>
          <div className={classes.textReminderDate}>{completeDate}</div>
          <div style={{ color: 'rgba(0,0,0,0.8)', fontSize: '0.8em' }}>{startTime} - {endTime}</div>
        </div>
      </div>

    </>
  )
}

function ErrorBody (props) {
  const classes = calendarStyles()
  return (
    <>
      <div style={{ height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'solid black 1pt', borderRadius: 5, flexDirection: 'column' }}>
        <Warning />
        <Typography className={classes.timeSelctionError}>That time slot is no longer available</Typography>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button style={{ border: '1px solid black', marginTop: '10px' }} onClick={() => props.fetchNewTimes()}>Select a new time</Button>
      </div>
    </>
  )
}

function CalendarHeader (props) {
  const classes = calendarStyles()

  return (
    <div className={classes.calendarDropHeader} style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div className={classes.title}>
        <DateRangeIcon />
        <span style={{ marginLeft: 8 }}>Meeting Scheduled!</span>
      </div>
    </div>
  )
}

function EmailConfirmationBox (props) {
  const { token, chatServiceUrl } = useContext(SessionContext)
  const classes = calendarStyles()
  const [loading, setLoading] = useState(false)
  const [timeSelectionError, setTimeSelectionError] = useState(false)

  const message = props.drop.data.visitor_email

  return (
    <div>
      {timeSelectionError
        ? <ErrorBody fetchNewTimes={() => props.setFailedTimeRequest(true)} />
        : (
          <>
            <div className={classes.emailConfirmDiv}>
              <div>
                The email I have for you is
              </div>
              <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {message}
              </div>
              <div>
                Is this correct?
              </div>
            </div>
            <div className={classes.textReminderButtonDiv}>
              <Button
                className={classes.showMoreButton}
                onClick={() => {
                  setLoading(true)
                  createCalendarEventWrap({ event_id: props.drop.event_id, start: props.start, end: props.end, startTimestamp: props.startTimestamp, endTimestamp: props.endTimestamp, token, chatServiceUrl })
                    .then(resp => {
                      if (resp === false) {
                        setLoading(false)
                        setTimeSelectionError(true)
                      }
                    })
                }}
              >
                Yes
                {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
              </Button>
              <Button
                className={classes.showMoreButton}
                onClick={() => {
                  props.emailKnownHandler(false)
                }}
              >
                No
              </Button>
            </div>
          </>
        )}
    </div>
  )
}

function EmailInput (props) {
  const { token, chatServiceUrl } = useContext(SessionContext)
  const classes = calendarStyles()
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [badEmail, setBadEmail] = useState(false)
  const [timeSelectionError, setTimeSelectionError] = useState(false)

  let message = 'Which email would you like us to send your invite to?'

  if (props.switchEmail) {
    message = 'Enter your new email.'
  }

  const handleEmail = (event) => {
    setEmail(event.target.value)
  }

  function checkEmail () {
    if (email) {
      const emailString = email.split('@')
      if (emailString.length !== 2) {
        return false
      }
      const leftSide = emailString[0].trim()
      const rightSide = emailString[1].trim()
      if (leftSide.length < 1) {
        return false
      }
      if (rightSide.length < 3) {
        return false
      }
      const rightSideList = rightSide.split('.')
      if (rightSideList.length < 2) {
        return false
      }
      if (rightSideList[0].trim().length < 1) {
        return false
      }
      if (rightSideList[1].trim().length < 1) {
        return false
      }
      if (email[email.length - 1] === '.') {
        return false
      }
      return true
    }
    return false
  }

  function handleClick () {
    if (checkEmail()) {
      setLoading(true)
      registerEmailReminder({ calendarDropEventID: props.drop.event_id, email: email, token, chatServiceUrl })
        .then(response => {
          return createCalendarEventWrap({ event_id: props.drop.event_id, start: props.start, end: props.end, startTimestamp: props.startTimestamp, endTimestamp: props.endTimestamp, token, chatServiceUrl })
            .then(resp => {
              if (resp === false) {
                setLoading(false)
                setTimeSelectionError(true)
              }
            })
        })
    } else {
      setBadEmail(true)
    }
  }

  if (badEmail) {
    message = 'Please enter a valid email address.'
  }
  return (
    <div>
      {timeSelectionError ? <ErrorBody fetchNewTimes={() => props.setFailedTimeRequest(true)} />
        : (
          <>
            <div className={classes.meetingTime} style={{ display: 'flex', padding: 20, marginBottom: 15, textAlign: 'center' }}>
              {message}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '6fr 1fr', gridGap: 10 }}>
              <div>
                <TextField
                  variant='outlined'
                  label='Email'
                  fullWidth
                  style={{ marginTop: -5, marginBottom: 10, marginRight: 10 }}
                  onChange={handleEmail}
                  autoFocus
                  type='email'
                  pattern='.+@'
                />
              </div>
              <div>
                <button
                  type='submit'
                  variant='outlined'
                  style={{ backgroundColor: 'white', marginTop: -5, height: 55, cursor: 'pointer' }}
                  onClick={() => {
                    handleClick()
                  }}
                >
                  <Check />
                  {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </button>
              </div>
            </div>
          </>
        )}

    </div>
  )
}

function BoxBody (props) {
  const classes = calendarStyles()
  const startDate = parseISO(props.start)
  const endDate = parseISO(props.end)
  const completeDate = dateFormat(startDate, 'dddd, mmmm dS')
  const startTime = dateFormat(startDate, 'shortTime')
  const endTime = dateFormat(endDate, 'shortTime')

  if (!props.slots) {
    return (
      <div className={classes.calendarDropLoading}>
        <CircularProgress
          style={{ height: 60, width: 60 }}
        />
      </div>
    )
  }
  if (!props.emailKnown) {
    const switchEmail = (props.drop.data.visitor_email || props.drop.data.visitor_other_email)
    return (
      <div className={classes.calendarDropComplete}>
        <div>
          <EmailReminderSection
            firstName={props.agentName}
            completeDate={completeDate}
            startTime={startTime}
            endTime={endTime}
            avatarUrl={props.avatarUrl}
            drop={props.drop}
          />
        </div>
        <EmailInput
          switchEmail={switchEmail}
          avatarUrl={props.avatarUrl}
          agentName={props.agentName}
          slots={props.slots}
          drop={props.drop}
          emailKnown={props.emailKnown}
          emailKnownHandler={props.emailKnownHandler}
          start={props.start}
          end={props.end}
          startTimestamp={props.startTimestamp}
          endTimestamp={props.endTimestamp}
          setFailedTimeRequest={props.setFailedTimeRequest}
        />
      </div>
    )
  }
  return (
    <div className={classes.calendarDropComplete}>
      <div>
        <EmailReminderSection
          firstName={props.agentName}
          completeDate={completeDate}
          startTime={startTime}
          endTime={endTime}
          avatarUrl={props.avatarUrl}
          drop={props.drop}
        />
      </div>
      <EmailConfirmationBox
        avatarUrl={props.avatarUrl}
        agentName={props.agentName}
        slots={props.slots}
        drop={props.drop}
        emailKnown={props.emailKnown}
        emailKnownHandler={props.emailKnownHandler}
        start={props.start}
        end={props.end}
        startTimestamp={props.startTimestamp}
        endTimestamp={props.endTimestamp}
        setFailedTimeRequest={props.setFailedTimeRequest}
      />
    </div>
  )
}

function EmailConfirmation (props) {
  const classes = calendarStyles()
  const [emailKnown, setEmailKnown] = useState(props.drop.data.visitor_email || props.drop.data.visitor_other_email)

  return (
    <div className={classes.calendarDropOuter}>
      <CalendarHeader
        drop={props.drop}
      />
      <BoxBody
        avatarUrl={props.avatarUrl}
        agentName={props.agentName}
        slots
        drop={props.drop}
        emailKnown={emailKnown}
        emailKnownHandler={setEmailKnown}
        start={props.start}
        end={props.end}
        startTimestamp={props.startTimestamp}
        endTimestamp={props.endTimestamp}
        setFailedTimeRequest={props.setFailedTimeRequest}
      />
    </div>
  )
}

export default EmailConfirmation
